import type { ClientSdk } from "./ClientSdk"
import { isTauriRuntime } from "./runtime"
import { TauriClientSdk } from "./TauriClientSdk"
import { BrowserClientSdk } from "./BrowserClientSdk"

// NOTE: this singleton deliberately does NOT live in a file named `clientSdk.ts` — on a
// case-insensitive filesystem (default macOS/Windows) that collides with `ClientSdk.ts` (the
// interface file, imported above) since both resolve to the same path on disk.

/** Selected once at module load: `npm run tauri dev`/a bundled app gets `TauriClientSdk`, a plain
 * `npm run dev` browser tab gets `BrowserClientSdk`. See `ClientSdk.ts` for what each backs. */
export const clientSdk: ClientSdk = isTauriRuntime() ? new TauriClientSdk() : new BrowserClientSdk()
